// Align submenus to the left if they overflow the viewport
function setupSubmenuAlignment() {
  const parentMenuItems = document.querySelectorAll(
    '[id^="menu-primary"] .menu-item-has-children, [id^="menu-languages"] .menu-item-has-children'
  );
  if (parentMenuItems) {
    // Detect and add class on mouse enter
    parentMenuItems.forEach(item => {
      item.addEventListener('mouseenter', (e) => {
        const subMenu = e.currentTarget.querySelector('.sub-menu');
        if (subMenu) {
          const rect = subMenu.getBoundingClientRect();
          if (rect.right > window.innerWidth) {
            subMenu.classList.add('menu-align-left');
          }

          // Adjust submenu position if it overflows the viewport, if so add overflow handling
          const subMenuRect = subMenu.getBoundingClientRect();
          if (subMenuRect.bottom > window.innerHeight) {
            subMenu.style.maxHeight = `${window.innerHeight - subMenuRect.top - 10}px`; // 10px padding
            subMenu.style.overflowY = 'auto';
          }
        }
      });
    });
  }
}

function mobileMenuButtonHandler() {
  // Mobile menu toggle
  const menuToggle = document.getElementById('menuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const menuItems = document.querySelectorAll('.mobile-menu__item');
  if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
      e.currentTarget.classList.toggle('opened');
      mobileMenu.classList.toggle('opened');
      document.body.classList.toggle('no-scroll');
      menuItems.forEach(item => item.classList.remove('opened'));
    });
  }

  // Next submenu handler
  const nextButtons = document.querySelectorAll('.mobile-menu__list-item a');
  nextButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const parentId = e.currentTarget.getAttribute('data-parent-id');
      if (!parentId) {
        return;
      }

      const targetMenu = document.querySelector(`.mobile-menu__item[data-parent-id="${parentId}"]`);
      if (targetMenu) {
        e.preventDefault();
        targetMenu.classList.add('opened');
      }
    });
  });

  // Back submenu handler
  const backButtons = document.querySelectorAll('.mobile-menu__back');
  backButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const currentMenu = e.currentTarget.closest('.mobile-menu__item')
      if (currentMenu) {
        currentMenu.classList.remove('opened');
      }
    });
  });
}

function openCloseDesktopMenu() {
  // Toggle opened state for menu items with children
  const menuParentLinks = document.querySelectorAll('.menu-item-has-children > a');  
  menuParentLinks.forEach(link => {
    link.addEventListener('click', (e) => {  
      e.preventDefault();
      const parentItem = e.currentTarget.closest('.menu-item-has-children');
      if (!parentItem) return;

      const isOpening = !parentItem.classList.contains('opened');
      parentItem.classList.toggle('opened');

      // Keep only one opened submenu branch while preserving active ancestors.
      if (isOpening) {
        document.querySelectorAll('.menu-item-has-children.opened').forEach(item => {
          if (
            item !== parentItem &&
            !item.contains(parentItem) &&
            !parentItem.contains(item)
          ) {
            item.classList.remove('opened');
          }
        });

        parentItem
          .querySelectorAll('.menu-item-has-children.opened')
          .forEach(item => item.classList.remove('opened'));
      }
    });
  });

  // Close opened menus on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('.menu-item-has-children.opened').forEach(item => {
      item.classList.remove('opened');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupSubmenuAlignment();
  mobileMenuButtonHandler();
  openCloseDesktopMenu();
});
